<template>
  <div>
    <main-layout>
      <v-container id="crm" fluid>
        <v-layout wrap>
          <v-flex xs12 sm4>
            <h3 class="title">Member</h3>
          </v-flex>
          <v-flex xs12 sm8 class="text-xs-right">
            <template v-if="loading">
              <v-btn outline loading color="grey"></v-btn>
            </template>
            <template v-else>
              <v-btn
                style="margin-right: 6px !important"
                color="grey"
                outline
                @click="onExportCustomer()"
              >
                <em class="fas fa-file-export" />
                &nbsp;
                {{ $t('export') }}
              </v-btn>
            </template>

            <v-btn dark depressed color="primary" @click="showAdvance = !showAdvance">
              <v-icon>search</v-icon>
              &nbsp;
              {{ $t('advanced search') }}&nbsp;
              <em v-if="!showAdvance" class="fas fa-angle-down" />
              <em v-else class="fas fa-angle-up" />
            </v-btn>
          </v-flex>
        </v-layout>
        <div
          v-if="showAdvance"
          class="mb-4"
          style="border: 1px solid #eee; border-radius: 10px; position: relative"
        >
          <filter-member v-model="filter" :total_user="total_user">
            <v-btn outline color="grey" @click="clearSearch">{{ $t('Clear Search') }}</v-btn>
            <v-btn depressed color="primary" @click="onSearch">
              <em class="fas fa-search mr-1" />
              {{ $t('Search') }}
            </v-btn>
          </filter-member>
        </div>

        <div class="mt-4">
          <v-pagination
            v-model="pageNumber"
            :total-visible="15"
            :length="pagelength"
            @input="changePage"
          ></v-pagination>
        </div>

        <v-layout row wrap>
          <v-flex xs6></v-flex>
          <v-flex xs6>
            <div class="ma-2 text-xs-right">
              <span class="caption mr-2">{{ $t('Total') }}</span>

              <span :style="`font-size: 19px;color:${$vuetify.theme.primary};font-weight: 600`">{{
                total_user | numberFormat
              }}</span>
            </div>
          </v-flex>
        </v-layout>
        <v-data-table
          :loading="loading"
          :headers="filteredHeader"
          :items="usersFormat"
          class="elevation-1"
          :pagination.sync="pagination"
          hide-actions
        >
          <template #items="props">
            <member-item v-model="props.item"></member-item>
          </template>

          <div slot="no-data" class="text-xs-center">{{ $t('No data') }}</div>
        </v-data-table>
      </v-container>
    </main-layout>
  </div>
</template>

<script>
import Members from './Members.js'

export default {
  mixins: [Members]
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AiraAiful/Members.vue